import { render } from "./Big5TextCheck.vue?vue&type=template&id=5b383708"
import script from "./Big5TextCheck.vue?vue&type=script&lang=js"
export * from "./Big5TextCheck.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__